<template lang="pug">
bottom-modal(:id="modalId", :loading='loading' width='w-xtra-large')
  span.text-capitalize(slot='header-text')
    | {{ title }}
  div(slot='body')
    .container
      .row
        .col-md-3
          filter-sidebar(ref="filterSidebar", :updateFilters="updateFilters", :onAddAllChange="setAddAllMatch")
        .col-md-9
          label.m-t-1 Selected Sites
          div(id="scrollableDiv" ref="scrollableDiv")
            div.multiselect__tag(v-for="(station, index) in selectedStations" :key="index")
              div.content-wrapper
                | {{ station.name }}
                i.multiselect__tag-icon.mdi.mdi-close-circle(@click="removeStation(station)")
                  span.sr-only Remove

          v-server-table(ref='datatable' :url='stationsUrl' :columns='columns' :options='tableOptions' :name='tableName')
            template(slot='select' slot-scope='props')
              label.md-check
                input(:disabled='addAllMatching' :checked="props.row.selected" :value='props.row.id' v-model='selectedStationIds' @change="handleCheckboxChange(props.row)" type='checkbox')
                i.indigo

  button.btn.btn-fw.primary(slot='footer' :disabled='onLoading(outletLoading)' @click='applyStation')
    v-loading(:loader='outletLoading')
      | Save

</template>

<script>
import reject from 'lodash/reject';
import { mapGetters, mapActions } from 'vuex';
import FilterSidebar from './templates/filter-sidebar';
import UserMixin from './user-mixin';

export default {
    components: {
        FilterSidebar,
    },

    mixins: [UserMixin],

    props: {
        user: {
            type: Object,
            required: true,
        },
        title: {
            type: String,
            required: false,
            default: 'Select stations',
        },
    },

    data() {
        return {
            outletLoading: false,
            addAllMatching: false,
            selectedStationIds: [],
            selectedStations: [],
            filters: {
                label: [],
                excludeLabel: [],
                search: null,
            },
            tableName: 'STATION_LIST_POOL',
            columns: ['select', 'code', 'name'],
        };
    },

    computed: {
        ...mapGetters('user', ['stationsPool']),

        loading() {
            return this.onLoading('fetch-station-list');
        },

        modalId() {
            return 'station-list-popup';
        },

        stationsUrl() {
            let url = Laroute.route('franchise.user.outlets');

            if (this.user.id != null) {
                url = url + '?user_id=' + this.user.id;
            }

            return url;
        },

        tableOptions() {
            return {
                sortable: [],
                filterable: false,
                params: {
                    label_ids: this.filters.label.map(t => t.id),
                    exclude_label_ids: this.filters.excludeLabel.map(t => t.id),
                    query: this.filters.search,
                    update_only: this.updateMode,
                },
                headings: {
                    select: (h, row) => {
                        return require('./heading-select-station').call(
                            this,
                            h,
                            row,
                        );
                    },
                    code: 'Site Id',
                    name: 'Name',
                },
            };
        },
    },

    created() {
        this.$on('show-station-list', updateMode => {
            this.reset(updateMode);
            this.refreshFilters();
        });
    },

    mounted() {
        var that = this;
        this.refreshOutletList(null);

        $('#station-popup').on('hidden.bs.modal', function(e) {
            that.errors.clear();
            this.addAllMatching = false;
        });

        this.stationShow();

        this.setInitialSelectedStationIds();
    },

    methods: {
        ...mapActions('outlet', ['getOutletListIfNecessary']),
        ...mapActions('user', ['getStations', 'setUserAttr']),

        getStationName(stationId) {
            const station = this.user.tenant_outlets.find(
                station => station.id === stationId,
            );
            return station ? station.name : ''; // Adjust if station name might be null
        },

        isSelected(station) {
            return this.selectedStationIds.some(
                selected => selected.id === station.id,
            );
        },

        stationShow() {
            this.$on('show-station-list', id => {
                this.showModal();
            });
        },

        showModal() {
            $('#station-list-popup').modal('show');
        },

        hideModal() {
            $('#station-list-popup').modal('hide');
        },

        reset(updateMode) {
            this.updateMode = updateMode;
            this.filters.label = this.user.included_labels;
            this.filters.excludeLabel = this.user.excluded_labels;
            this.filters.search = null;

            this.$refs.filterSidebar.$emit('reset-filters', this.filters);
            this.setInitialSelectedStationIds();
        },

        setInitialSelectedStationIds() {
            this.selectedStationIds = this.user.tenant_outlets.map(
                station => station.id,
            );
            this.selectedStations = this.user.tenant_outlets.map(
                station => station,
            );
        },

        refreshOutletList: _.debounce(function(query) {
            this.getOutletListIfNecessary({ query: query });
        }, 500),

        refreshStations() {
            this.$refs.datatable.refresh();
        },

        updateFilters(filters) {
            this.filters = filters;
            this.refreshFilters();
        },

        refreshFilters() {
            // Workaround because the params doesn't seems to be
            // updated when changed within the same event bus
            this.$nextTick(this.refreshStations);
        },

        setAddAllMatch(addAll) {
            this.addAllMatching = addAll;
        },

        async applyStation() {
            try {
                let params = {};
                if (this.addAllMatching) {
                    params = {
                        params: {
                            label_ids: this.filters.label.map(t => t.id),
                            exclude_label_ids: this.filters.excludeLabel.map(
                                t => t.id,
                            ),
                            query: this.filters.search,
                        },
                    };
                }
                params.userId = this.user.id;

                await this.getStations(params);

                const selectedStations = this.selectedStations;

                this.setUserAttr({
                    key: 'tenant_outlets',
                    value: selectedStations,
                });

                this.setUserAttr({
                    key: 'included_labels',
                    value: this.filters.label,
                });

                this.setUserAttr({
                    key: 'excluded_labels',
                    value: this.filters.excludeLabel,
                });

                this.hideModal();
            } catch (e) {
                this.showApiError(e);
            }
        },

        async onChangeSelectAll(value) {
            if (value) {
                const data = {
                    query: this.filters.search,
                    label_ids: this.filters.label.map(t => t.id),
                    exclude_label_ids: this.filters.excludeLabel.map(t => t.id),
                };

                await this.getStations(data);

                this.selectedStationIds = this.stationsPool.map(t => t.id);
                this.selectedStations = this.stationsPool;
            } else {
                this.selectedStationIds = [];
                this.selectedStations = [];
            }
        },

        removeStation(station) {
            this.selectedStationIds = this.selectedStationIds.filter(
                id => id !== station.id,
            );
            this.selectedStationIds = reject(
                this.selectedStationIds,
                o => o.id === station.id,
            );
            this.selectedStations = reject(
                this.selectedStations,
                o => o.id === station.id,
            );
        },

        handleCheckboxChange(row) {
            const index = this.selectedStations.findIndex(
                station => station.id === row.id,
            );

            if (index !== -1) {
                // If the station is already selected, remove it
                this.selectedStations = [
                    ...this.selectedStations.slice(0, index),
                    ...this.selectedStations.slice(index + 1),
                ];
            } else {
                // If the station is not selected, add it
                this.selectedStations = [...this.selectedStations, row];
            }
        },
    },
};
</script>

<style>
.my-custom-scrollbar {
    position: relative;
    height: 200px;
    overflow: overlay;
}
.table-wrapper-scroll-y {
    display: compact;
}

#scrollableDiv {
    height: 100px; /* Set the desired height */
    overflow-y: scroll; /* Add a vertical scrollbar */
    border: 1px solid #ccc; /* Optional: Add border for styling */
    padding: 10px; /* Optional: Add padding for spacing */
    border-radius: 10px; /* Add rounded corners */
    margin: 10px 0px 10px 0px;
}

.content-wrapper {
    display: flex;
    align-items: center;
}

button {
    margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/user/station_list.vue